import { useState, useEffect } from "react";
import {
  getLawyers,
  createLawyer,
  updateLawyer,
  deleteLawyer,
  pauseLawyerUpdates,
  resumeLawyerUpdates,
} from "../services/LawyerService";

export default function useLawyers() {
  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const fetchLawyers = async () => {
    setLoading(true);
    // setError("");
    try {
      const res = await getLawyers();
      setLawyers(res.data.data);
    } catch {
      setError("Error al cargar los abogados.");
    } finally {
      setLoading(false);
    }
  };

  const addLawyer = async (data) => {
    try {
      const res = await createLawyer(data);
      if (res.data?.status === "success") {
        setSuccess(res.data.message);
        await fetchLawyers();
      }
      return res;
    } catch (error) {
      throw error;
    }
  };

  const editLawyer = async (id, data) => {
    try {
      const res = await updateLawyer(id, data);
      if (res.data?.status === "success") {
        setSuccess(res.data.message);
        await fetchLawyers();
      }
      return res;
    } catch (error) {
      throw error;
    }
  };

  const removeLawyer = async (id) => {
    try {
      const res = await deleteLawyer(id);
      if (res.data?.status === "success") {
        setSuccess(res.data.message);
        await fetchLawyers();
      }
    } catch {
      setError("Error al eliminar abogado.");
    }
  };

  const pauseLawyer = async (id) => {
    try {
      const res = await pauseLawyerUpdates(id);
      if (res.data?.status === "success") {
        setSuccess(res.data.message);
        await fetchLawyers();
      }
      return res;
    } catch (error) {
      throw error;
    }
  };

  const resumeLawyer = async (id) => {
    try {
      const res = await resumeLawyerUpdates(id);
      if (res.data?.status === "success") {
        setSuccess(res.data.message);
        await fetchLawyers();
      }
      return res;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    fetchLawyers();
  }, []);

  return {
    lawyers,
    loading,
    error,
    success,
    setError,
    setSuccess,
    fetchLawyers,
    addLawyer,
    editLawyer,
    removeLawyer,
    pauseLawyer,
    resumeLawyer,
  };
}
